<template>
  <div>
    <div class="award-title mb16">实物奖品名单</div>
      <jd-form
        class="mb16"
        ref="physicalAwardFormRef"
        :form-info="formSchema"
        @search="search"
      />

    <div class="btnBox flex-between">
      <div>
        <jd-button
          style="margin-right: 8px"
          type="break"
          @click="addCrowd"
          >按查询结果生成人群</jd-button
        >
        <jd-button
          @click="physicalBatchShipment"
          v-preventReClick
          :disabled="!dataSource.length"
          >批量发货</jd-button
        >
      </div>
      <jd-button
        type="text"
        @click="exportPhysicalAward"
        v-preventReClick
        >导出</jd-button
      >
    </div>

    <div class="new-table-box">
      <jd-table
        :loading="tableLoading"
        :tableData="dataSource"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        :pageInfo="{
          pageSize: formList.size,
          pageNum: formList.current,
          total: formList.total,
        }"
        style="width: 100%;"
        @handlePage="handleCurrentChangeAll"
      >
        <el-table-column prop="chaosPin" label="用户Pin"  width="150"></el-table-column>
        <el-table-column prop="memberNick" label="用户昵称" width="180"></el-table-column>
        <el-table-column prop="memberLevel" label="会员等级">
          <template slot-scope="scope">
            <span>{{ levelMap[scope.row.memberLevel] || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
        <el-table-column prop="recordId" label="中奖ID" width="180"></el-table-column>
        <el-table-column label="奖品名称" width="300">
          <template slot-scope="scope">
            <div class="goodsInfo">
              <div class="goodsInfo_logo">
                <img :src="scope.row.logo" alt="" />
              </div>
              <template v-if="scope.row.isGoodManage!=1">
                <div
                  class="goodsInfo_text"
                  v-if="scope.row.skuId"
                >
                  <a
                    :href="`http://item.jd.com/${scope.row.skuId}.html`"
                    target="_blank"
                    >{{ scope.row.skuName }}<br />
                    <span style="color: #666666"
                      >skuId:{{ scope.row.skuId }}</span
                    >
                  </a>
                </div>
                <div class="goodsInfo_text" v-else>
                  <div>{{ scope.row.skuName }}</div>
                </div>
              </template>
              <template v-else>
                <div
                  class="goodsInfo_text"
                  v-if="scope.row.assetsId"
                >
                  <a
                    @click="handleToGoods(scope.row.assetsId)"
                    target="_blank"
                    >{{ scope.row.title }}<br />
                    <span style="color: #666666"
                      >id:{{ scope.row.assetsId }}</span
                    >
                  </a>
                </div>
                <div class="goodsInfo_text" v-else>
                  <div>{{ scope.row.title }}</div>
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="prizeTitle"
            label="附加信息"
            width="200"
          >
           <template slot="header" slot-scope="scope">
            <span>附加信息</span>
           </template>
           <template slot-scope="scope">
            <div v-if="scope.row.shouldCollectExtraData==1">
              <div v-html="getAnswerText(scope.row)"></div>
            </div>
            <div v-else>-</div>
           </template>
          </el-table-column>
        <el-table-column label="参与活动订单" width="160">
          <template slot-scope="{ row }">
            <div v-if="row.joinOrders && row.joinOrders.length > 0">
              <div v-for="(order, index) in row.joinOrders" :key="index" style="margin-bottom: 5px;">
                <el-tooltip effect="light" placement="top-start">
                  <template slot="content">
                    <div class="order-info">
                      <div>订单号：{{ order.orderId || '-' }}</div>
                      <div>订单金额：{{ order.orderPayment ? order.orderPayment + '元' : '-' }}</div>
                      <div>订单状态：{{ order.orderStateRemark || '-' }}</div>
                    </div>
                  </template>
                  <span style="color: #3159ff; cursor: pointer;">{{ order.orderId || "-" }}</span>
                </el-tooltip>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column label="中奖订单" width="160">
          <template slot-scope="{ row }">
            <div v-if="row.winOrders && row.winOrders.length > 0">
              <div v-for="(order, index) in row.winOrders" :key="index" style="margin-bottom: 5px;">
                <el-tooltip effect="light" placement="top-start">
                  <template slot="content">
                    <div class="order-info">
                      <div>订单号：{{ order.orderId || '-' }}</div>
                      <div>订单金额：{{ order.orderPayment ? order.orderPayment + '元' : '-' }}</div>
                      <div>订单状态：{{ order.orderStateRemark || '-' }}</div>
                    </div>
                  </template>
                  <span style="color: #3159ff; cursor: pointer;">{{ order.orderId || "-" }}</span>
                </el-tooltip>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column  prop="winOrderBelongShopNameStr" label="下单店铺" width="180">
          <template slot-scope="{ row }">
            {{ row.winOrderBelongShopNameStr || '-' }}
          </template>
        </el-table-column>
        <el-table-column  prop="orderPriceSum" label="订单金额" width="180"></el-table-column>
        <el-table-column prop="grantTime" label="发货时间" width="180">
          <template slot-scope="{ row }">
            <div>{{ row.grantTime ? row.grantTime : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="发货状态" width="180">
          <template slot-scope="{ row }">
            <div>{{ [2,5,7].includes(row.status) ? ([2,7].includes(row.status)?'未发货':'已发货') : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverName" label="收件人" width="180">
          <template slot-scope="{ row, $index }">
            <div class="open">
              {{ row.receiverName ? row.receiverName : '-' }}
              <!-- <div class="openHover"
                  v-if="
                    row.receiverName &&
                    row.receiverName.indexOf('*') != -1
                  "
                  @click="handleDecrypt('receiverName','dataSource',row,$index)"
                >
                  展开
                </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverMobile" label="收件人手机号" width="200">
          <template slot-scope="{ row, $index }">
            <div class="open">
              {{ row.receiverMobile ? row.receiverMobile : '-' }}
              <!-- <div class="openHover"
                  v-if="
                    row.receiverMobile &&
                    row.receiverMobile.indexOf('*') != -1
                  "
                  @click="handleDecrypt('receiverMobile','dataSource',row,$index)"
                >
                  展开
                </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverAddress" label="收件人地区" width="200">
          <template slot-scope="{ row, $index }">
            <div class="open">
              {{ row.receiverAddress ? row.receiverAddress : '-' }}
              <!-- <div class="openHover"
                  v-if="
                    row.receiverAddress &&
                    row.receiverAddress.indexOf('*') != -1
                  "
                  @click="handleDecrypt('receiverAddress','dataSource',row,$index)"
                >
                  展开
                </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="detailedAddress" label="收件人详细地址" width="200">
          <template slot-scope="{ row, $index }">
            <div class="open">
              {{ row.detailedAddress ? row.detailedAddress : '-' }}
              <!-- <div class="openHover"
                  v-if="
                    row.detailedAddress &&
                    row.detailedAddress.indexOf('*') != -1
                  "
                  @click="handleDecrypt('detailedAddress','dataSource',row,$index)"
                >
                  展开
                </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="isPassOrderEnd" label="是否满足确认收货天数" width="180">
          <template slot-scope="{ row }">
            {{ [0,1].includes(row.isPassOrderEnd)? (row.isPassOrderEnd==0?'未满足':'已满足'): '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="isPassActivityEnd" label="是否满足活动结束天数" width="180">
          <template slot-scope="{ row }">
            {{ [0,1].includes(row.isPassActivityEnd)? (row.isPassActivityEnd==0?'未满足':'已满足'): '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="billCode" label="快递单号" width="180">
          <template slot-scope="{ row }">
            <div>{{ row.billCode? row.billCode : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="360">
          <template slot-scope="{ row }">
            <jd-button type="blueText" v-if="row.status == 5" @click="markDelivery(row)">取消发货</jd-button>
            <jd-button type="blueText" v-if="[2,7].includes(row.status) && row.id" :disabled="!row.id" @click="markDelivery(row)">标记发货</jd-button>
            <jd-button type="blueText" @click="enterBill(row)" size="small" :disabled="!row.id">录入快递单号</jd-button>
            <jd-button type="blueText" style="margin-left: 8px" @click="revocationDeliverGoods(row)" v-if="[3,5,6,2,7].includes(Number(row.prizeStatus)) && currentRuleInfo.supportRollback==1">撤回奖品</jd-button>
            <jd-button
              type="blueText"
              v-if="row.status != 5 && row.status != 8"
              @click="editAddress(row)"
            >
              修改地址
            </jd-button>
          </template>
        </el-table-column>
      </jd-table>
    </div>

    <!-- 录入快递单号弹窗 -->
    <el-dialog
      title="录入快递单号"
      width="420px"
      :visible.sync="enterBillDialog"
      @close="enterBillDialog = false"
      class="enter_coutier_num_dialog"
    >
      <el-form :model="billDataForm" label-width="86px" class="new-input-box">
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="billDataForm.enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="enter_coutier_num_dialog_floor">
        <jd-button @click="enterBillDialog=false">取消</jd-button>
        <jd-button type="break" style="margin-left: 8px;" @click="confirmBillCode" :loading="submitLoading">确定</jd-button>
      </div>
    </el-dialog>

    <!-- 生成人群 -->
    <crowdDialog v-if="isShowCrowdDialog" 
      :isShowCrowdDialog="isShowCrowdDialog" 
      :searchForm="formList" 
      :activityType="rowData.activityType"
      :source="4"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose" 
    />

    <!-- 导出 -->
    <generate 
      :control="openRemarkDialog" 
      v-if="openRemarkDialog" 
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import { goodRecords, purchaseActivityWithdraw } from "@/api/jhk/paradiseAndTaskCommonController.js";
import {
  markingSendStatusLockRight, fullGiftRecord, signIssuance
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import statisticsData from "@/mixin/activity_statistics_new.js";
import crowdDialog from "../crowd-Dialog.vue";
export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
  },
  props: {
    rowData: { // 活动详情
      type: Object,
      default: () => ({})
    },
    currentShop: { // 当前选择店铺
      type: String,
      default: '',
    },
    sellerLinkList: {
      type: Array,
      default: () => []
    },
    prizeNames: {
      type: Array,
      default: () => []
    },
    shopList: {
      type: Array,
      default: () => []
    },
    levelList: {
      type: Array,
      default: () => []
    },
    levelMap: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    currentRuleInfo() {
      return JSON.parse(this.rowData.ruleInfo || '{}') || {};
    }
  },
  data() {
    return {
      formSchema: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户Pin,精确查询",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "发货时间：",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          // startTime:this.getDateStr(-30) + " 00:00:00",
          // endTime:this.getDateStr(0) + " 23:59:59",
          startTime:'',//进来默认时间但没传值，所以测试叫我去掉默认值
          endTime:'',
          startKey: "deliveryTimeStart",
          endKey: "deliveryTimeEnd",
        },
        {
          label: "发货状态：",
          prop: "status",
          type: "Select",
          value: "",
          placeholder: "请选择",
          options: [
            { label: "全部", value: "" },
            { label: "未发货", value: "2,7" },
            { label: "已发货", value: "5" },
          ],
        },
        {
          label: "是否提交地址：",
          prop: "commitAddressFlag",
          type: "Select",
          value: "",
          placeholder: "请选择",
          options: [
            { label: "全部", value: ""},
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: []
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: this.prizeNames,
          multiple: true,
        },
        {
          label: "奖品名称：",
          prop: "prizeIds",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: this.prizeNames,
          multiple: true,
        },
        {
          label: "中奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "下单店铺：",
          prop: "orderVenderId",
          type: "Select",
          value: "",
          options: [],
        }
      ],
      dataSource: [], // 数据源
      formList: {
        size: 10,
        current: 1,
        activityId: this.rowData.id,
        total: 0
      },
      tableLoading: false,
      billDataForm: {}, // 录入快递单号表单
      enterBillDialog: false, // 录入快递单号弹窗
      enterCoutierNum: '', // 录入快递单号
      batchMarkVisible: false, // 批量标记发货
      currentRow: {}, // 当前行数据
      submitLoading: false,
      selectList: [], // 选中的数组
      physicalBatchShipmentShow: false, // 批量发货弹窗
      physicalBatchShipmentFrom: {}, // 批量发货表单
      downloadResData: {}, // 下载模板返回的数据
      downloadUserList: [], // 下载模板失败用户
      openRemarkDialog: false, // 导出
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: '', // 默认值文本
      searchInfo: {}, // 搜索参数
    }
  },
  watch: {
    sellerLinkList: {
      handler(newVal, oldVal) {
        if(newVal.length) {
          const list = newVal.map((item)=>{
            return {
              label: item.sellerLinkName,
              value: item.id
            }
          })
          this.formSchema.some((item)=>{
            if(item.prop=='sellerLinkId') {
              item.options = list
            }
          })
        }
      },
      deep: true,
    },
    shopList: {
      handler(newVal, oldVal) {
        const index = this.formSchema.findIndex(item => item.prop == 'orderVenderId')
        if(index > -1) {
          this.formSchema[index].options = newVal.map((item)=>{
            return {
              label: item.shopTitle,
              value: item.venderId
            }
          })
        }
      },
      immediate: true,
    },
    prizeNames: {
      handler(newVal, oldVal) {
        if(newVal.length) {
          this.formSchema.forEach((item)=>{
            if(item.prop=='prizeIds') {
              item.options = newVal
            }
          })
        }
      },
      immediate: true,
      deep: true,
    },
    // 监听会员等级列表变化，更新查询表单的会员等级选项
    levelList: {
      handler(newVal, oldVal) {
        const index = this.formSchema.findIndex(item => item.prop == 'memberLevel')
        if(index > -1) {
          this.formSchema[index].options = [
            { label: "全部", value: "" },
            { label: "非会员", value: "0" },
            ...newVal
          ]
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    editAddress(row) {
      this.$emit('editAddress', row)
    },
    getAnswerText(){
      return (row)=>{
        let text = ''
        if(row.extraQuestion.type==1) {
          row.extraQuestion.options.some(item => {
            if(row.extraQuestionAnswer.optionIds&&item.optionId == row.extraQuestionAnswer.optionIds[0]){
              text = item.description
            }
          })
        } else if(row.extraQuestion.type==2) {
          if(row.extraQuestionAnswer.optionIds&&row.extraQuestionAnswer.optionIds.length>0) {
            const list = row.extraQuestion.options.filter(item => {
              return row.extraQuestionAnswer.optionIds.includes(Number(item.optionId))
            })
            const descriptions = list.map(item => item.description).join(",")
            text = `<div>${descriptions}</div>` 
          }
        } else {
          text = row.extraQuestionAnswer.submitInputText ? row.extraQuestionAnswer.submitInputText : '-'
        }
        return text;
      }
    },
    search(val, type) {
      console.log(val, type)
      this.formList.current = 1;
      delete this.formList.total;
      this.formList = { ...this.formList, ...val, prizeIds: val.prizeIds.length>0 ? val.prizeIds.join(',') : '' };
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      goodRecords(this.formList).then((res) => {
        let { records=[], total=0 } = res.data;
        this.tableLoading = false;
        if(res.code == 1){
          this.dataSource = records;
          this.formList.total = Number(total);
          this.loading = false;
        } else {
          this.$message.error(res.message);
          this.loading = false;
        }
      }).finally(()=> this.loading = false);
    },
    handleCurrentChangeAll(page) {
      this.formList.current = page.pageNum;
      this.formList.size = page.pageSize;
      this.getList();
    },
    handleSizeChange(val) {
      this.formList.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.getList();
    },
    /**
     * 标记发货
     * @param row ]
     */
    markDelivery(row) {
      signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.getList();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
    /**
     * 录入快递单号
     * @param row ]
     */
    enterBill(row) {
      this.billDataForm = {};
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.enterBillDialog = true;
    },
    /**
     * 确认录入快递单号
     */
    confirmBillCode() {
      if(!this.billDataForm.enterCoutierNum) {
        this.$message.error('请输入快递单号');
        return;
      }
      let params = {
        id: this.currentRow.id,
        billCode: this.billDataForm.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      };
      this.submitLoading = true;
      markingSendStatusLockRight(params)
        .then((res) => {
          if (res.code == 1) {
            this.enterBillDialog = false;
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("录入快递单号失败");
        }).finally(()=> this.submitLoading= false);
    },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    /**
     * 生成人群
     */
     addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = '满额有礼-实物奖品名单-'
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false; 
      // 关闭时重置
      if(this.hasDefaultValue){
        this.hasDefaultValue = false;
        this.defaultValueText = '';
      }
    },
    /**
     * 导出
     */
    exportPhysicalAward() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
     confirmExport(exportRemark='') {
      let obj = this.$refs.physicalAwardFormRef.export_fun2();
      if(obj.prizeIds&&obj.prizeIds.length){
        obj.prizeIds = obj.prizeIds.join(',')
      }
      let params = {
        ...obj,
        activityId: this.rowData.id,
        current: 1,
        size: 9999999,
        exportRemark
      }
      this.tableLoading=true;
      fullGiftRecord(params).then((res) => {
        this.tableLoading = false;
      });
    },
    handleSelectionChanges(val) {
      this.selectList = val;
    },
    /**
     * 批量发货
     */
    physicalBatchShipment() {
      this.$emit('openPhysicalBatchShipment');
    },
    // 撤回发货（实物奖品）
    revocationDeliverGoods(row){
      let { recordId } = row;
      this.$confirm(`您的奖品状态为${row.prizeStatus === 2 || row.prizeStatus === 7 ? '未发放' : '已发放'}，是否进行撤回！`,"提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(res=>{
        purchaseActivityWithdraw({
        recordId
        }).then(res=>{
          if(res.code == 1){
            this.$message.success("撤回奖品成功")
            this.getList()
          }else{
            this.$message.error(res.message)
          }
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .mb16 {
    margin-bottom: 16px;
  }
  .award-title {
    font-weight: bold;
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btnBox {
    margin-bottom: 16px;
  }

  .physical_batch_shipment_dialog {
  .upload-demo {
    /deep/ .el-upload .el-upload-dragger {
      width: 250px;
    }
  }
  .download_template_box {
    position: absolute;
    right: 24px;
    top: 17%;
  }
  .downloadMsgBox {
    width: 100%;
    min-height: 100px;
  }
  .physical_batch_shipment_dialog_floor {
    text-align: right;
    width: 100%;
  }
}

.goodsInfo {
  display: flex;
  align-items: center;
  &_logo {
    display: flex;
    width: 80px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 70px;
      border-radius: 4px;
    }
  }
  &_text {
    flex: 1;
    color: #666666;
    cursor: pointer;
    margin-left: 5px;
    a {
      color: #666666;
      margin-top: 5px;
    }
  }
}
.order-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}
</style>